import { Button, Col, Flex, Row, Spin } from "antd";
import { useNavigate } from "react-router";

const LayoutColdStorage = ({ selectedStorage, loading }) => {
  const navigate = useNavigate();

  const handleNavigate = (id, name, row, section, temporary) => {
    if (!name) return;

    const codifiedName = temporary
      ? "T-CS" + name.split(" ")[2]
      : "CS" + name.split(" ")[2];

    navigate(`/detail-stock/${codifiedName}-${row}${section}`, {
      state: { id, row, section, name: codifiedName },
    });
  };

  const chunkIntoColumns = (rows, columns = 3) => {
    const chunkSize = Math.ceil(rows.length / columns);
    const chunks = [];
    for (let i = 0; i < rows.length; i += chunkSize) {
      chunks.push(rows.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const rowChunks = chunkIntoColumns(selectedStorage?.rows || [], 3);

  return (
    <>
      {loading ? (
        <Flex justify="center" align="center">
          <Spin size="large" style={{ marginTop: "10rem" }} />
        </Flex>
      ) : (
        <Row>
          <Col span={24} style={{ textAlign: "center", marginTop: "1rem" }}>
            <h3>{selectedStorage?.warehouse_name}</h3>
          </Col>

          {/* Rows */}
          <Col span={24}>
            <Row gutter={16}>
              {rowChunks.map((chunk, colIndex) => (
                <Col
                  span={8}
                  key={colIndex}
                  style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Row Titles */}
                  <Row>
                    <Col span={8}>
                      <p style={{ marginLeft: "20px" }}>Section A</p>
                    </Col>
                    <Col span={8} style={{ backgroundColor: "#fdf53b" }}>
                      <p>Area T (Temporary)</p>
                    </Col>
                    <Col span={8}>
                      <p style={{ marginRight: "20px" }}>Section B</p>
                    </Col>
                  </Row>
                  {chunk.map((row, rowIndex) => {
                    return (
                      <Row key={rowIndex}>
                        {/* Section A */}
                        <Col span={8}>
                          <Flex justify="end" align="end">
                            {(row?.sections?.[0]?.section === "A"
                              ? [...row?.sections?.[0]?.columns].reverse()
                              : row?.sections?.[0]?.columns
                            )
                              ?.reduce((acc, column) => {
                                if (column.column_name === "S") {
                                  return [column, ...acc];
                                }
                                return [...acc, column];
                              }, [])
                              ?.map((column, index) => (
                                <Row gutter={0} key={index}>
                                  <Col span={24}>
                                    {column?.levels
                                      ?.slice()
                                      .reverse()
                                      .map((rack, index) => (
                                        <div
                                          style={{ width: "100%" }}
                                          key={index}
                                        >
                                          <Button
                                            variant="outlined"
                                            className={`${
                                              rack?.status === "empty"
                                                ? "rack-available"
                                                : "rack-unavailable"
                                            }`}
                                            style={{
                                              borderColor: "black",
                                              color: "black",
                                              borderRadius: 0,
                                              borderWidth: "1px",
                                              margin: 0,
                                              width: "100%",
                                            }}
                                            onClick={() => {
                                              handleNavigate(
                                                selectedStorage?.warehouse_id,
                                                selectedStorage?.warehouse_name,
                                                row?.row_number,
                                                "A",
                                                false
                                              );
                                            }}
                                          >
                                            <Row
                                              gutter={0}
                                              style={{
                                                width: "1rem",
                                              }}
                                            >
                                              <Col
                                                span={24}
                                                style={{ fontSize: "12px" }}
                                              >
                                                {rack.level}
                                              </Col>
                                            </Row>
                                          </Button>
                                        </div>
                                      ))}
                                  </Col>
                                  <Col span={24}>
                                    <p
                                      style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {column.column_name}
                                    </p>
                                  </Col>
                                </Row>
                              ))}
                          </Flex>
                        </Col>

                        {/* Temporary Area */}
                        <Col span={8}>
                          <div
                            style={{
                              fontSize: "2rem",
                              padding: "2rem",
                              backgroundColor: "#fdf53b",
                              margin: "0 auto",
                              height: "100%",
                            }}
                          >
                            {row.row_number}
                          </div>
                        </Col>

                        {/* Section B */}
                        <Col span={8}>
                          <Flex justify="start" align="start">
                            {(row?.sections?.[1]?.section === "A"
                              ? [...row?.sections?.[1]?.columns].reverse()
                              : row?.sections?.[1]?.columns
                            )
                              ?.reduce((acc, column) => {
                                if (column.column_name === "S") {
                                  return [column, ...acc];
                                }
                                return [...acc, column];
                              }, [])
                              ?.map((column, index) => (
                                <Row gutter={0} key={index}>
                                  <Col span={24}>
                                    {column?.levels
                                      ?.slice()
                                      .reverse()
                                      .map((rack, index) => (
                                        <div
                                          style={{ width: "100%" }}
                                          key={index}
                                        >
                                          <Button
                                            variant="outlined"
                                            className={`${
                                              rack?.status === "empty"
                                                ? "rack-available"
                                                : "rack-unavailable"
                                            }`}
                                            style={{
                                              borderColor: "black",
                                              color: "black",
                                              borderRadius: 0,
                                              borderWidth: "1px",
                                              margin: 0,
                                              width: "100%",
                                            }}
                                            onClick={() => {
                                              handleNavigate(
                                                selectedStorage?.warehouse_id,
                                                selectedStorage?.warehouse_name,
                                                row?.row_number,
                                                "B",
                                                false
                                              );
                                            }}
                                          >
                                            <Row
                                              gutter={0}
                                              style={{
                                                width: "1rem",
                                              }}
                                            >
                                              <Col
                                                span={24}
                                                style={{ fontSize: "12px" }}
                                              >
                                                {rack.level}
                                              </Col>
                                            </Row>
                                          </Button>
                                        </div>
                                      ))}
                                  </Col>
                                  <Col span={24}>
                                    <p
                                      style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {column.column_name}
                                    </p>
                                  </Col>
                                </Row>
                              ))}
                          </Flex>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default LayoutColdStorage;
